export enum SectionMessageHook {
  Section_Message = 'section-message',
  Section_Notification = 'section-notification',
}
